let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1z9sG")).then(() => parcelRequire('03QGa'));